// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options,
  getNavigation,
  getDriveStatistics,
  getDataSync,
  getGps,
  reportUnexpectedEvent,
  reportStarted,
  reportFinished,
  getRawPhotos,
  getPhoto,
  getThumbnailByUuid,
  getEvidencePackageByUuid,
  getPhotos,
  getPhotosThumbnail,
  getPanoramaPreviewBase64,
  getRawPhoto,
  getPhotos3D,
  changeCameraMode,
  pause,
  unpause,
  skipSegment,
  getDrivers,
  driverSignIn,
  driverSignOut,
  getGoToGarage,
  putGoToGarage,
  getDisplayableEvents,
  directions,
} from '../sdk.gen'
import { queryOptions, type UseMutationOptions, type DefaultError } from '@tanstack/react-query'
import type {
  GetNavigationData,
  GetDriveStatisticsData,
  GetDataSyncData,
  GetGpsData,
  ReportUnexpectedEventData,
  ReportUnexpectedEventResponse,
  ReportStartedData,
  ReportStartedResponse,
  ReportFinishedData,
  ReportFinishedResponse,
  GetRawPhotosData,
  GetPhotoData,
  GetThumbnailByUuidData,
  GetEvidencePackageByUuidData,
  GetPhotosData,
  GetPhotosThumbnailData,
  GetPanoramaPreviewBase64Data,
  GetRawPhotoData,
  GetPhotos3dData,
  ChangeCameraModeData,
  ChangeCameraModeResponse,
  PauseData,
  PauseResponse,
  UnpauseData,
  UnpauseResponse,
  SkipSegmentData,
  SkipSegmentResponse,
  GetDriversData,
  DriverSignInData,
  DriverSignInResponse,
  DriverSignOutData,
  DriverSignOutResponse,
  GetGoToGarageData,
  PutGoToGarageData,
  PutGoToGarageResponse,
  GetDisplayableEventsData,
  DirectionsData,
  DirectionsResponse,
} from '../types.gen'
import { client as _heyApiClient } from './initializer'

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    _infinite?: boolean
    tags?: ReadonlyArray<string>
  },
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? _heyApiClient).getConfig().baseUrl,
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (tags) {
    params.tags = tags
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const getNavigationQueryKey = (options?: Options<GetNavigationData>) => createQueryKey('getNavigation', options)

/**
 * Fetch Navigation Data
 */
export const getNavigationOptions = (options?: Options<GetNavigationData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getNavigation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getNavigationQueryKey(options),
  })
}

export const getDriveStatisticsQueryKey = (options?: Options<GetDriveStatisticsData>) =>
  createQueryKey('getDriveStatistics', options)

/**
 * Fetch drive statistics for current drive
 */
export const getDriveStatisticsOptions = (options?: Options<GetDriveStatisticsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDriveStatistics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDriveStatisticsQueryKey(options),
  })
}

export const getDataSyncQueryKey = (options?: Options<GetDataSyncData>) => createQueryKey('getDataSync', options)

/**
 * Fetch Data Sync state
 */
export const getDataSyncOptions = (options?: Options<GetDataSyncData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDataSync({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDataSyncQueryKey(options),
  })
}

export const getGpsQueryKey = (options?: Options<GetGpsData>) => createQueryKey('getGps', options)

/**
 * Get current GPS coordinates
 */
export const getGpsOptions = (options?: Options<GetGpsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGps({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getGpsQueryKey(options),
  })
}

export const reportUnexpectedEventQueryKey = (options: Options<ReportUnexpectedEventData>) =>
  createQueryKey('reportUnexpectedEvent', options)

/**
 * Report an unexpected event (e.g., blocked road)
 */
export const reportUnexpectedEventOptions = (options: Options<ReportUnexpectedEventData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportUnexpectedEvent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: reportUnexpectedEventQueryKey(options),
  })
}

/**
 * Report an unexpected event (e.g., blocked road)
 */
export const reportUnexpectedEventMutation = (
  options?: Partial<Options<ReportUnexpectedEventData>>
): UseMutationOptions<ReportUnexpectedEventResponse, DefaultError, Options<ReportUnexpectedEventData>> => {
  const mutationOptions: UseMutationOptions<
    ReportUnexpectedEventResponse,
    DefaultError,
    Options<ReportUnexpectedEventData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await reportUnexpectedEvent({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const reportStartedQueryKey = (options?: Options<ReportStartedData>) => createQueryKey('reportStarted', options)

/**
 * Triggered by the driver to indicate that the vehicle is at the beginning of the route and about to start the drive.
 * Before starting the drive, a check of the camera systems should be performed.
 */
export const reportStartedOptions = (options?: Options<ReportStartedData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportStarted({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: reportStartedQueryKey(options),
  })
}

/**
 * Triggered by the driver to indicate that the vehicle is at the beginning of the route and about to start the drive.
 * Before starting the drive, a check of the camera systems should be performed.
 */
export const reportStartedMutation = (
  options?: Partial<Options<ReportStartedData>>
): UseMutationOptions<ReportStartedResponse, DefaultError, Options<ReportStartedData>> => {
  const mutationOptions: UseMutationOptions<ReportStartedResponse, DefaultError, Options<ReportStartedData>> = {
    mutationFn: async localOptions => {
      const { data } = await reportStarted({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const reportFinishedQueryKey = (options?: Options<ReportFinishedData>) =>
  createQueryKey('reportFinished', options)

/**
 * Report that the requested drive is finished (triggered by the driver)
 * When the drive is marked as finished, the navigation endpoint should start returning a different one.
 */
export const reportFinishedOptions = (options?: Options<ReportFinishedData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportFinished({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: reportFinishedQueryKey(options),
  })
}

/**
 * Report that the requested drive is finished (triggered by the driver)
 * When the drive is marked as finished, the navigation endpoint should start returning a different one.
 */
export const reportFinishedMutation = (
  options?: Partial<Options<ReportFinishedData>>
): UseMutationOptions<ReportFinishedResponse, DefaultError, Options<ReportFinishedData>> => {
  const mutationOptions: UseMutationOptions<ReportFinishedResponse, DefaultError, Options<ReportFinishedData>> = {
    mutationFn: async localOptions => {
      const { data } = await reportFinished({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getRawPhotosQueryKey = (options?: Options<GetRawPhotosData>) => createQueryKey('getRawPhotos', options)

/**
 * Retrieve a raw unenhanced photo with captures from all the cameras to confirm that the systems are operational.
 */
export const getRawPhotosOptions = (options?: Options<GetRawPhotosData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRawPhotos({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRawPhotosQueryKey(options),
  })
}

export const getPhotoQueryKey = (options: Options<GetPhotoData>) => createQueryKey('getPhoto', options)

/**
 * Retrieve a raw photo from a single camera.
 */
export const getPhotoOptions = (options: Options<GetPhotoData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPhoto({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPhotoQueryKey(options),
  })
}

export const getThumbnailByUuidQueryKey = (options: Options<GetThumbnailByUuidData>) =>
  createQueryKey('getThumbnailByUuid', options)

/**
 * Retrieve a thumbnail image of evidence-package.
 */
export const getThumbnailByUuidOptions = (options: Options<GetThumbnailByUuidData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getThumbnailByUuid({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getThumbnailByUuidQueryKey(options),
  })
}

export const getEvidencePackageByUuidQueryKey = (options: Options<GetEvidencePackageByUuidData>) =>
  createQueryKey('getEvidencePackageByUuid', options)

/**
 * Retrieve a .7z archive of evidence-package.
 */
export const getEvidencePackageByUuidOptions = (options: Options<GetEvidencePackageByUuidData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvidencePackageByUuid({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getEvidencePackageByUuidQueryKey(options),
  })
}

export const getPhotosQueryKey = (options?: Options<GetPhotosData>) => createQueryKey('getPhotos', options)

/**
 * Retrieve a photo with captures from all cameras to confirm that the systems are operational.
 */
export const getPhotosOptions = (options?: Options<GetPhotosData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPhotos({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPhotosQueryKey(options),
  })
}

export const getPhotosThumbnailQueryKey = (options?: Options<GetPhotosThumbnailData>) =>
  createQueryKey('getPhotosThumbnail', options)

/**
 * Retrieve thumbnail photos from all cameras
 */
export const getPhotosThumbnailOptions = (options?: Options<GetPhotosThumbnailData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPhotosThumbnail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPhotosThumbnailQueryKey(options),
  })
}

export const getPanoramaPreviewBase64QueryKey = (options?: Options<GetPanoramaPreviewBase64Data>) =>
  createQueryKey('getPanoramaPreviewBase64', options)

/**
 * Retrieve a panorama preview base64 image with timestamp metadata
 */
export const getPanoramaPreviewBase64Options = (options?: Options<GetPanoramaPreviewBase64Data>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPanoramaPreviewBase64({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPanoramaPreviewBase64QueryKey(options),
  })
}

export const getRawPhotoQueryKey = (options: Options<GetRawPhotoData>) => createQueryKey('getRawPhoto', options)

/**
 * Retrieve a photo from a single camera.
 */
export const getRawPhotoOptions = (options: Options<GetRawPhotoData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRawPhoto({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRawPhotoQueryKey(options),
  })
}

export const getPhotos3dQueryKey = (options?: Options<GetPhotos3dData>) => createQueryKey('getPhotos3D', options)

/**
 * Retrieve a range-photo with captures from all 3D cameras to confirm that the systems are operational.
 */
export const getPhotos3dOptions = (options?: Options<GetPhotos3dData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPhotos3D({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPhotos3dQueryKey(options),
  })
}

export const changeCameraModeQueryKey = (options: Options<ChangeCameraModeData>) =>
  createQueryKey('changeCameraMode', options)

/**
 * Change camera mode to the passed one
 * When this endpoint is invoked it sets the camera mode to either day or night based on the mode specified.
 */
export const changeCameraModeOptions = (options: Options<ChangeCameraModeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await changeCameraMode({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: changeCameraModeQueryKey(options),
  })
}

/**
 * Change camera mode to the passed one
 * When this endpoint is invoked it sets the camera mode to either day or night based on the mode specified.
 */
export const changeCameraModeMutation = (
  options?: Partial<Options<ChangeCameraModeData>>
): UseMutationOptions<ChangeCameraModeResponse, DefaultError, Options<ChangeCameraModeData>> => {
  const mutationOptions: UseMutationOptions<ChangeCameraModeResponse, DefaultError, Options<ChangeCameraModeData>> = {
    mutationFn: async localOptions => {
      const { data } = await changeCameraMode({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const pauseQueryKey = (options?: Options<PauseData>) => createQueryKey('pause', options)

/**
 * Pause segment processing.
 * When this endpoint is invoked all passed segments will be ignored until unpaused
 */
export const pauseOptions = (options?: Options<PauseData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await pause({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: pauseQueryKey(options),
  })
}

/**
 * Pause segment processing.
 * When this endpoint is invoked all passed segments will be ignored until unpaused
 */
export const pauseMutation = (
  options?: Partial<Options<PauseData>>
): UseMutationOptions<PauseResponse, DefaultError, Options<PauseData>> => {
  const mutationOptions: UseMutationOptions<PauseResponse, DefaultError, Options<PauseData>> = {
    mutationFn: async localOptions => {
      const { data } = await pause({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const unpauseQueryKey = (options?: Options<UnpauseData>) => createQueryKey('unpause', options)

/**
 * Unpause segment processing.
 * When this endpoint is invoked all passed segments will processed again
 */
export const unpauseOptions = (options?: Options<UnpauseData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await unpause({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: unpauseQueryKey(options),
  })
}

/**
 * Unpause segment processing.
 * When this endpoint is invoked all passed segments will processed again
 */
export const unpauseMutation = (
  options?: Partial<Options<UnpauseData>>
): UseMutationOptions<UnpauseResponse, DefaultError, Options<UnpauseData>> => {
  const mutationOptions: UseMutationOptions<UnpauseResponse, DefaultError, Options<UnpauseData>> = {
    mutationFn: async localOptions => {
      const { data } = await unpause({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const skipSegmentQueryKey = (options?: Options<SkipSegmentData>) => createQueryKey('skipSegment', options)

/**
 * Skip current segment to the following one
 * When this endpoint is invoked the current segment is moved to another one
 */
export const skipSegmentOptions = (options?: Options<SkipSegmentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await skipSegment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: skipSegmentQueryKey(options),
  })
}

/**
 * Skip current segment to the following one
 * When this endpoint is invoked the current segment is moved to another one
 */
export const skipSegmentMutation = (
  options?: Partial<Options<SkipSegmentData>>
): UseMutationOptions<SkipSegmentResponse, DefaultError, Options<SkipSegmentData>> => {
  const mutationOptions: UseMutationOptions<SkipSegmentResponse, DefaultError, Options<SkipSegmentData>> = {
    mutationFn: async localOptions => {
      const { data } = await skipSegment({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getDriversQueryKey = (options?: Options<GetDriversData>) => createQueryKey('getDrivers', options)

/**
 * Retrieve a list of available drivers
 */
export const getDriversOptions = (options?: Options<GetDriversData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDrivers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDriversQueryKey(options),
  })
}

export const driverSignInQueryKey = (options: Options<DriverSignInData>) => createQueryKey('driverSignIn', options)

/**
 * Sign in as a driver and start a work period
 */
export const driverSignInOptions = (options: Options<DriverSignInData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await driverSignIn({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: driverSignInQueryKey(options),
  })
}

/**
 * Sign in as a driver and start a work period
 */
export const driverSignInMutation = (
  options?: Partial<Options<DriverSignInData>>
): UseMutationOptions<DriverSignInResponse, DefaultError, Options<DriverSignInData>> => {
  const mutationOptions: UseMutationOptions<DriverSignInResponse, DefaultError, Options<DriverSignInData>> = {
    mutationFn: async localOptions => {
      const { data } = await driverSignIn({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const driverSignOutQueryKey = (options?: Options<DriverSignOutData>) => createQueryKey('driverSignOut', options)

/**
 * Sign a driver out and terminate a work period
 */
export const driverSignOutOptions = (options?: Options<DriverSignOutData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await driverSignOut({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: driverSignOutQueryKey(options),
  })
}

/**
 * Sign a driver out and terminate a work period
 */
export const driverSignOutMutation = (
  options?: Partial<Options<DriverSignOutData>>
): UseMutationOptions<DriverSignOutResponse, DefaultError, Options<DriverSignOutData>> => {
  const mutationOptions: UseMutationOptions<DriverSignOutResponse, DefaultError, Options<DriverSignOutData>> = {
    mutationFn: async localOptions => {
      const { data } = await driverSignOut({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getGoToGarageQueryKey = (options?: Options<GetGoToGarageData>) => createQueryKey('getGoToGarage', options)

/**
 * Get go-to-garage flag
 */
export const getGoToGarageOptions = (options?: Options<GetGoToGarageData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGoToGarage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getGoToGarageQueryKey(options),
  })
}

/**
 * Set/unset go-to-garage flag
 */
export const putGoToGarageMutation = (
  options?: Partial<Options<PutGoToGarageData>>
): UseMutationOptions<PutGoToGarageResponse, DefaultError, Options<PutGoToGarageData>> => {
  const mutationOptions: UseMutationOptions<PutGoToGarageResponse, DefaultError, Options<PutGoToGarageData>> = {
    mutationFn: async localOptions => {
      const { data } = await putGoToGarage({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getDisplayableEventsQueryKey = (options?: Options<GetDisplayableEventsData>) =>
  createQueryKey('getDisplayableEvents', options)

/**
 * Retrieve displayable evidence data for the current drive
 * Returns evidence data including signpost and vehicle detection coordinates that can be displayed to the driver during navigation. This includes locations where signposts and vehicles were detected along the route.
 */
export const getDisplayableEventsOptions = (options?: Options<GetDisplayableEventsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDisplayableEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDisplayableEventsQueryKey(options),
  })
}

export const directionsQueryKey = (options: Options<DirectionsData>) => createQueryKey('directions', options)

/**
 * Get directions from Google Route API
 * When this endpoint is invoked it ask the CitySense API to fetch directions from Google Routes API
 */
export const directionsOptions = (options: Options<DirectionsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await directions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: directionsQueryKey(options),
  })
}

/**
 * Get directions from Google Route API
 * When this endpoint is invoked it ask the CitySense API to fetch directions from Google Routes API
 */
export const directionsMutation = (
  options?: Partial<Options<DirectionsData>>
): UseMutationOptions<DirectionsResponse, DefaultError, Options<DirectionsData>> => {
  const mutationOptions: UseMutationOptions<DirectionsResponse, DefaultError, Options<DirectionsData>> = {
    mutationFn: async localOptions => {
      const { data } = await directions({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}
